import axios from "axios"
axios.defaults.withCredentials = true; // 
axios.defaults.timeout = 60000;
axios.defaults.retry = 0;// 重试次数，加上本身共请求2次
axios.defaults.retryDelay = 1000;// 请求的间隙
axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
  var config = err.config;
  if (!config || !config.retry)config.retry = axios.defaults.retry;
  if (!config.retry) return Promise.reject(err);// 如果配置不存在或未设置重试选项，则拒绝
  config.__retryCount = config.__retryCount || 0;// 设置变量以跟踪重试次数
  if (config.__retryCount >= config.retry) {// 判断是否超过总重试次数
    return Promise.reject(err);// 返回错误并退出自动重试
  }
  config.__retryCount += 1;// 增加重试次数
  var backoff = new Promise(function (resolve) {// 创建新的Promise
    setTimeout(function () {
      resolve();
    }, config.retryDelay || axios.defaults.retryDelay || 1);
  });
  return backoff.then(function () {// 返回重试请求
    return axios(config);
  });
});
var qs = require('qs');//会将参数转为 get表单请求的方式，值是 key-value
//isform=true代表提交的是表单
const postData = (url, params, headers,isform=false) =>{

  console.log(`url: ${url}`)
  return new Promise(function(resolve, rejectes){
    if(!headers){//application/json;//结构复杂的话使用json更合理
      headers = {
        "Content-Type": "application/json;"//默认值
      };
    }
    if(headers.hasOwnProperty("Content-Type")&&headers["Content-Type"].indexOf("application/x-www-form-urlencoded;")>-1&&!isform) {
      params = qs.stringify(params);
    }
    headers["Content-Type"] += " charset=UTF-8";
    if(url.indexOf('/v3/')==-1){
      url = "/v1"+url;
    }

    if(url.indexOf('?')==-1){
      url = url + '?token='+ localStorage.getItem("token");
    } else {
      url = url + '&token='+ localStorage.getItem("token");
    }

    let option = {
      headers: headers,
      withCredentials: true,//不携带身份凭证，
      method: 'post',
      data: params,
      url:  url
    };

    axios(option).then(function(res){
        
      if(res.status==200&&(!res.data.code||res.data.code==200)){
        res.data.code = 0;
        resolve(res.data);
      }else {
        if(res.data.code===401){
         console.log("用户或密码错误")
        }else {
          console.log("执行异常")
          // Vue.prototype.errorInfo(res.data.msg);
        }
        rejectes(res.data);
        if(res.data.code===401){
          // window.location.href = "/#/login"
        }
      }
    }).catch(() => {
      rejectes({code:5000,msg: "我忙不过来了，请稍后再试~"});
    });
  });
}

const postxml = (url, params, headers) =>{
  return new Promise(function(resolve, rejectes){
    if(!headers){//application/json;//结构复杂的话使用json更合理
      headers = {
        "Content-Type": "application/xml;"//默认值
      };
    }
    
    headers["Content-Type"] += " charset=UTF-8";

    if(url.indexOf('?')==-1){
      url = url + '?token='+ localStorage.getItem("token");
    } else {
      url = url + '&token='+ localStorage.getItem("token");
    }

    let option = {
      headers: headers,
      withCredentials: true,//不携带身份凭证，
      method: 'post',
      data: params
    };
    axios(option).then(function(res){
      if(res.status==200&&(!res.data.code||res.data.code==200)){
        res.data.code = 0;
        resolve(res.data);
      }else {
        if(res.data.code===401){
          console.log("用户或密码错误")
        }else {
          console.log("执行异常")
          // Vue.prototype.errorInfo(res.data.msg);
        }
        rejectes(res.data);
        if(res.data.code===401){
          // window.location.href = "/#/login"
        }
      }
    }).catch(() => {
      rejectes({code:5000,msg: "我忙不过来了，请稍后再试~"});
    });
  });
}

const getData = (url, params) =>{
  return new Promise(function(resolve, rejectes){
    if(url.indexOf('/v3/')==-1){
      url = "/v1"+url;
    }
    
    if(url.indexOf('?')==-1){
      url = url + '?token='+ localStorage.getItem("token");
    } else {
      url = url + '&token='+ localStorage.getItem("token");
    }
    
    let option = {
      withCredentials: true,//不携带身份凭证，
      method: 'get',
      data: params,
      params: params
    };
    axios(option).then(function(res){
      if(!res.data.code||res.data.code==200){
        res.data.code = 0;
        resolve(res.data);
      }else {
        if(res.data.msg)alert(res.data.msg);
        rejectes(res.data);
        if(res.data.code===401){
          // window.location.href = "/#/login"
        }
      }
    }).catch(() => {
      rejectes({code:5000,msg: "我忙不过来了，请稍后再试~"});
    });
  });
}


const deleteData = (url, params) =>{
  return new Promise(function(resolve, rejectes){
    if(url.indexOf('/v3/')==-1){
      url = "/v1"+url;
    }
    
    if(url.indexOf('?')==-1){
      url = url + '?token='+ localStorage.getItem("token");
    } else {
      url = url + '&token='+ localStorage.getItem("token");
    }
    
    let option = {
      withCredentials: true,//不携带身份凭证，
      method: 'delete',
      data: params,
      params: params
    };
    axios(option).then(function(res){
      if(!res.data.code||res.data.code==200){
        res.data.code = 0;
        resolve(res.data);
      }else {
        if(res.data.msg)alert(res.data.msg);
        rejectes(res.data);
        if(res.data.code===401){
          // window.location.href = "/#/login"
        }
      }
    }).catch(() => {
      rejectes({code:5000,msg: "我忙不过来了，请稍后再试~"});
    });
  });
}


export default {
  postData: postData,
  getData: getData,
  deleteData: deleteData,
  postxml: postxml,
  axios
}
